module.exports = __webpack_public_path__ + "static/pc-e5da6b5da056eeefde29c30b1d7b6258.png";